var onCallSearchResultData: any;
var onCallSearchByList: any;
var onCallSiteList: any;
var onCallSiteId: any;
var onCallNetworkId: any;

const setonCallSearchResultDataFromComponent = (data: any) => {
  onCallSearchResultData = data;
};

const getonCallSearchResultDataFromComponent = () => {
  return onCallSearchResultData;
};

const setonCallSearchByListFromComponent = (data: any) => {
  onCallSearchByList = data;
};

const getonCallSearchByListFromComponent = () => {
  return onCallSearchByList;
};

const setonCallSiteListFromComponent = (data: any) => {
  onCallSiteList = data;
};

const getonCallSiteListFromComponent = () => {
  return onCallSiteList;
};

const setonCallSiteIdFromComponent = (data: any) => {
  onCallSiteId = data;
};

const getonCallSiteIdFromComponent = () => {
  return onCallSiteId;
};

const setonCallNetworkListFromComponent = (data: any) => {
  onCallNetworkId = data;
};

const getonCallNetworkListFromComponent = () => {
  return onCallNetworkId;
};

export const onCallSearchResultService = {
  setonCallSearchResultDataFromComponent,
  getonCallSearchResultDataFromComponent,
  setonCallSearchByListFromComponent,
  getonCallSearchByListFromComponent,
  setonCallSiteListFromComponent,
  getonCallSiteListFromComponent,
  setonCallNetworkListFromComponent,
  getonCallNetworkListFromComponent,
  setonCallSiteIdFromComponent,
  getonCallSiteIdFromComponent,
};
